import React from 'react';
import { cn } from '../../utils/utils.ts';

export const Stepper = ({ steps, currentStep, onStepClick, className, showDescriptions = true, stepLoading }) => {
  return (
    <div className={cn("flex items-center justify-between w-full", className)}>
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isClickable = onStepClick && (isCompleted || isActive);

        return (
          <React.Fragment key={step.id}>
            {index > 0 && (
              <div className="flex-1 h-0.5 bg-gray-200 mx-2">
                <div 
                  className={cn("h-full transition-all duration-300 ease-in-out", {
                    'bg-[var(--primary-font)]': isCompleted || isActive,
                    'bg-gray-200': !isCompleted && !isActive
                  })}
                  style={{
                    width: isCompleted ? '100%' : isActive ? '0%' : '0%',
                  }}
                />
              </div>
            )}
            <div 
              className={cn(
                "flex flex-col items-center cursor-pointer",
                { "cursor-pointer": isClickable },
                { "pointer-events-none opacity-50 cursor-default": !isClickable },
                { "pointer-events-none opacity-50 cursor-default": stepLoading }
              )}
              onClick={(e) => {
                e.preventDefault();
                onStepClick(index);
              }}
            >
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors duration-200 mb-1",
                    {
                      "bg-[var(--primary-font)] text-white": isActive || isCompleted,
                      "bg-gray-100 text-gray-500 border border-gray-300": !isActive && !isCompleted,
                    }
                  )}
                >
                  {isCompleted ? (
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    index + 1
                  )}
                </div>
                <div className="flex flex-col items-center">
                  <span
                    className={cn("text-xs font-medium text-center w-24", {
                      "text-[var(--primary-font)] font-semibold": isActive,
                      "text-gray-500": !isActive,
                    })}
                  >
                    {step.name}
                  </span>
                  {showDescriptions && step.description && (
                    <span
                      className={cn("text-xs text-center w-24 mt-1 line-clamp-2", {
                        "text-[var(--primary-font)] font-medium": isActive,
                        "text-gray-400": !isActive,
                      })}
                    >
                      {step.description}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export const StepContent = ({ children, isActive }) => {
  if (!isActive) return null;
  return <div className="mt-8">{children}</div>;
};
